import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ButtonUI from '../../../../components/UI/ButtonUI';
import { translate } from '../../../../utils/util';
import { Row, Modal, Button } from 'react-materialize';

const ReprocessModal = (props) => {
    useEffect(() => {
        if (props.selectedItems.length === 0) props.onCancel()
        // eslint-disable-next-line
    }, [props.selectedItems]);

    return (
        props.modalType !== 3 ?
            <Modal
                open={props.open}
                id={props.id || 'ModalPackList'}
                actions={
                    <Row className="center" style={{ height: "60%" }}>
                        <Button onClick={props.onCancel} className="col s6 btn waves-effect waves-light btn-flat" modal="close" disabled={props.disabledCancel}>
                            {translate('cancel', 'general')}
                        </Button>
                        <ButtonUI onClick={props.onConfirm} text={translate('confirm', 'general')} />
                    </Row>
                }
            >
                <div>
                    {props.open &&
                        <>
                            <Row className="center">
                                <div className="sixth-text-color center">
                                    <span className="title col s12">Confirmação</span>
                                    <span className="col s12">Confirma {props.modalType === 1 ? "a exclusão" : "o reprocessamento"} dos itens abaixo?</span>
                                </div>
                            </Row>
                            {props.selectedItems.map((item, index) => {
                                return (
                                    <div
                                        style={{ display: 'block', padding: '10px', height: 'auto' }}
                                        key={`oi-${index}`}
                                    >
                                        <span className="title sixth-text-color right">
                                            <i onClick={() => props.onDelete(item)} className="mdi mdi-close"></i>
                                        </span>
                                        <div>
                                            <span className="sixth-text-color" style={{ display: 'block' }}>{item.partNumber}</span>
                                            <span className="sixth-text-color" style={{ display: 'block' }}>{item.barCode}</span>
                                            <span className="sixth-text-color" style={{ display: 'block' }}>{item.area}</span>
                                            <span className="sixth-text-color" style={{ display: 'block' }}>{item.quantity - (item.quantityDownloaded ?? 0)}</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    }
                </div>
            </Modal>
            :
            <Modal
                open={props.open}
                id={props.id || 'ModalPackList'}
                actions={
                    <Row className="center" style={{ height: "60%" }}>
                        <Button onClick={props.onCancel} className="col s6 btn waves-effect waves-light btn-flat" modal="close" disabled={props.disabledCancel}>
                            {translate('cancel', 'general')}
                        </Button>
                        <ButtonUI onClick={props.onConfirm} text={translate('confirm', 'general')} />
                    </Row>
                }
            >
                <div>
                    {props.open &&
                        <>
                            <Row className="center">
                                <div className="sixth-text-color center">
                                    <span className="title col s12">Confirmação</span>
                                    <span className="col s12">Confirma a exclusão de todos os itens?</span>
                                </div>
                            </Row>
                        </>
                    }
                </div>
            </Modal>
    );
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReprocessModal)));
